@if (utbyte?.produktgrupper.length > 0) {
  <rask-header class="ps-0" size="4">{{ "Beräknat utbyte" | uppercase }}</rask-header>
  <rask-div-list [data]="utbyte.produktgrupper">
    <rask-list-column header="PRODUKTGRUPP" field="" >
      <ng-template let-row="row">
        <span>
          {{row.produktgrupp.namn}}
        </span>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="VOLYM M3F" field="kvantitetHa">
      <ng-template let-row="row">
        <span>
          {{getProduktgruppVolym(row.kvantitetHa)}}
          @if (showInfoIcon(row.produktgrupp.namn)) {
            <rask-info [infoIconSolid]="false" class="iconheight">
            Varav stamblock {{getProduktgruppVolymStamblock(row.produktgrupp.namn)}}</rask-info>
          }
        </span>
      </ng-template>
    </rask-list-column>
  </rask-div-list>
  <div class="summarize-footer">
    <div class="row rowfooter">
      <div class="col">
        <span>Summa</span>
      </div>
      <div class="col">
        <span aid="utbyte-summma">{{summaVolym}}</span>
      </div>
    </div>
    <div class="row rowfooter">
      <div class="col">
        <span>Timmerandel</span>
      </div>
      <div class="col">
        <span aid="utbyte-timmerandel">{{utbyteTimmerAndel}}%</span>
      </div>
    </div>
  </div>
}
